// extracted by mini-css-extract-plugin
export default {"top":"Decoration_top__ueIMz","left":"Decoration_left__IvGoT","right":"Decoration_right__NJpeI"};